/* __next_internal_client_entry_do_not_use__ IconButton,StyledIconButton,StyledIconWrapper auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useGetAttributes } from "@faire/web--source/slate/Button/utils";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { useMaybeDomainStripping } from "@faire/web--source/ui/hooks/useMaybeDomainStripping";
import React from "react";
import styled from "styled-components";
import { useShouldShowSpinner } from "../../ui/hooks/useShouldShowSpinner";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "../utils/highVisSlateComponent";
import { IconButtonStyles, IconWrapperStyles } from "./styles";
import { iconWrapperTheme } from "./theme";
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/slate/component/icon-button)
 */ export var IconButton = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var strictLocalize = useStrictLocalization().strictLocalize;
    var ariaLabel = props["aria-label"], buttonRef = props.buttonRef, dataTestId = props["data-test-id"], _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_loading = props.loading, loading = _props_loading === void 0 ? false : _props_loading, onClick = props.onClick, _props_shape = props.shape, shape = _props_shape === void 0 ? "circle" : _props_shape, _props_size = props.size, size = _props_size === void 0 ? "medium" : _props_size, _props_variant = props.variant, variant = _props_variant === void 0 ? "primary" : _props_variant, linkTo = props.linkTo, rest = _object_without_properties(props, [
        "aria-label",
        "buttonRef",
        "data-test-id",
        "disabled",
        "loading",
        "onClick",
        "shape",
        "size",
        "variant",
        "linkTo"
    ]);
    var _useShouldShowSpinner = useShouldShowSpinner(disabled, loading, onClick), isDisabled = _useShouldShowSpinner.isDisabled, handleClick = _useShouldShowSpinner.handleClick, shouldShowSpinner = _useShouldShowSpinner.shouldShowSpinner;
    var _useMaybeDomainStripping = useMaybeDomainStripping(linkTo, undefined), _useMaybeDomainStripping_potentiallyRelativeLink = _useMaybeDomainStripping.potentiallyRelativeLink, potentiallyRelativeLink = _useMaybeDomainStripping_potentiallyRelativeLink === void 0 ? linkTo : _useMaybeDomainStripping_potentiallyRelativeLink;
    var _useGetAttributes = useGetAttributes(_object_spread_props(_object_spread({}, props), {
        linkTo: potentiallyRelativeLink
    })), as = _useGetAttributes.as, linkProps = _useGetAttributes.linkProps;
    var loadingMessage = strictLocalize({
        id: "LJ8sQp",
        defaultMessage: [
            {
                type: 0,
                value: "Loading"
            }
        ]
    });
    return /*#__PURE__*/ _jsx(StyledIconButton, _object_spread_props(_object_spread({
        "aria-disabled": isDisabled,
        "aria-label": shouldShowSpinner ? loadingMessage : ariaLabel,
        "aria-live": "polite",
        disabled: isDisabled,
        "data-test-id": dataTestId,
        $loading: loading,
        as: as,
        onClick: handleClick,
        ref: buttonRef,
        $shape: shape,
        $variant: variant
    }, rest, linkProps), {
        children: /*#__PURE__*/ _jsx(StyledIconWrapper, {
            "aria-hidden": true,
            disabled: isDisabled,
            $shape: shape,
            $size: size,
            $variant: variant,
            children: shouldShowSpinner ? /*#__PURE__*/ _jsx(StyledLoadingSpinner, {
                variant: variant
            }) : children
        })
    }));
};
IconButton.displayName = "IconButton";
export var StyledIconButton = styled.button.withConfig({
    componentId: "sc-a5e379fb-0"
})([
    "",
    " ",
    ""
], IconButtonStyles, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
export var StyledIconWrapper = styled.div.withConfig({
    componentId: "sc-a5e379fb-1"
})([
    "",
    ""
], IconWrapperStyles);
var StyledLoadingSpinner = styled(LoadingSpinner).attrs(function(props) {
    var _props_variant = props.variant, variant = _props_variant === void 0 ? "primary" : _props_variant;
    var IconButtonVariantTheme = iconWrapperTheme[variant].loading;
    var color = (typeof IconButtonVariantTheme === "function" ? IconButtonVariantTheme({
        $variant: variant
    }) : IconButtonVariantTheme).color;
    return {
        color: color
    };
}).withConfig({
    componentId: "sc-a5e379fb-2"
})([
    ""
]);
